export default __webpack_public_path__ + "static/broadcastImg6-c40d9cdf3e59dff80e1917983ad6d21b.webp";